import api, { buildService } from './index'

export default {
  ...buildService('clients'),
  active: (id, newStatus) => api.put(`clients/${id}/active?status=${newStatus}`)
}
